<style></style>
<script>
    import { BSPost, BSGet } from '../js-core/conn/reqs'
    import ChangeDesc from '../components/shared/forms/ChangeDesc.svelte'
    import { Col, Container, Row } from "sveltestrap";

    export let params
    let descModalOpen
    let description
    let screenId
    const screenIndex = (params || {}).screen
    async function getScreenInfo() {
        const screensStr = localStorage.getItem("screensInfo");
        const screens = JSON.parse(screensStr);
        screenId = screens[screenIndex]._id
        // const nid = screens[screenIndex].nid
        // const res = await BSGet(`tv-owner/b-stick/${nid}`)
        return screens[screenIndex]
    }

    async function resetScreen({nid, uuid}) {
        if (confirm('Are you sure that you want to reset your screen?')) {
            const res = await BSPost(`tv-owner/b-stick/${screenId}/reset`, JSON.stringify({nid, uuid}))
            if (res.status !== 204) {
                alert("There was an error resetting your screen")
            } else {
                window.history.back()
            }
        }
    }

    async function changeDescription(description) {
        const res = await BSPost(`tv-owner/b-stick/${screenId}/description`, JSON.stringify({description}))
        if (res.status !== 204) {
            throw "There was an error updating your description"
        } else {
            window.history.back()
        }
    }
    const getScreenInfoProm = getScreenInfo()
</script>
{#await getScreenInfoProm}
    Getting your screen info...
{:then screen}
    <Container style="padding: 2.4rem 1rem;">
        <Row>
            <Col>
                <h3>Update your TV's description</h3>
                <p>
                   {screen.description || "No description yet? Add one"}
                </p>
                <button class="normal" on:click="{() => descModalOpen = true}">Change Description</button>
                {#if descModalOpen}
                    <ChangeDesc bind:open={descModalOpen} name="TV" description={screen.description} updateDesc={changeDescription}/>
                {/if}
            </Col>
        </Row>
    </Container>
    <Container style="padding: 2.4rem 1rem;">
        <Row>
            <Col>
                <h3>Screen Actions</h3>
                <p>
                    Reset your screen if you want to setup your screen on a different account or WiFi network
                </p>
                <button class="normal" on:click="{() => resetScreen(screen)}" style="background-color: #a00606">Reset Screen</button>
            </Col>
        </Row>
    </Container>
{:catch error}
    There was an error getting your screen information, please go back to the screens page and try again
{/await}
